import React from 'react'
import { uncontrollable } from 'uncontrollable'
import classes from '../Navbar.module.scss'

export class NavbarTabs extends React.Component {
  constructor (props, ...args) {
    super(props, ...args)

    this.renderTab = this.renderTab.bind(this)
  }

  renderTab (child) {
    if (!child) return child

    const { selectedKey, onSelect } = this.props
    const { selectKey } = child.props

    let props = {}
    if (selectKey) {
      if (selectedKey === selectKey) {
        props.active = true
      } else {
        props.onClick = () => onSelect(selectKey)
      }
    }

    return React.cloneElement(
      child,
      props
    )
  }

  render () {
    const {
      children,
      ...restProps
    } = this.props

    return (
      <div
        {...restProps}
        className={classes.navbarTabs}
      >
        {React.Children.map(children, this.renderTab)}
      </div>
    )
  }
}

export default uncontrollable(
  NavbarTabs,
  {
    selectedKey: 'onSelect'
  }
)
